/**
 * El resumen de arriba del listado — que además de contar, filtra.
 *
 * POR QUÉ EXISTE. Para saber cuántos tractores están de baja había que abrir
 * el desplegable de Estado, elegir "De baja", mirar el contador de filas y
 * volver atrás. Tres pasos para una pregunta que se hace todos los días.
 *
 * Acá los números están a la vista, y cada uno es además el filtro que lleva
 * a esas filas. Tocar el contador de "Sin dato" no es una acción distinta de
 * elegirlo en el desplegable: es el MISMO filtro, mostrado de una forma que
 * responde la pregunta antes de que la hagas.
 *
 * El primer casillero, "Todas", es el estado sin filtro. Está siempre, y es
 * la única forma de volver sin buscar dónde deshacer lo que se tocó.
 */
const ResumenBar = ({ resumen, filtroSelect, setSelect }) => {
  if (!resumen || resumen.items.length < 2) return null;

  const elegido = filtroSelect[resumen.columna] || "";

  const casillero = (valor, etiqueta, cantidad, tono) => (
    <button
      key={valor || "__todas"}
      type="button"
      className={`resumen-kpi ${tono ? `resumen-kpi--${tono}` : ""} ${
        elegido === valor ? "is-activo" : ""
      }`}
      aria-pressed={elegido === valor}
      onClick={() => setSelect(resumen.columna, elegido === valor ? "" : valor)}
    >
      <span className="resumen-kpi__n">{cantidad.toLocaleString("es-AR")}</span>
      <span className="resumen-kpi__l">{etiqueta}</span>
    </button>
  );

  return (
    <div className="resumen-bar" role="group" aria-label={`Por ${resumen.label}`}>
      {casillero("", "Todas", resumen.total, "")}
      {resumen.items.map((i) =>
        casillero(i.valor, i.valor, i.cantidad, i.tono),
      )}
    </div>
  );
};

export default ResumenBar;
